function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "15",
  viewBox: "0 0 12 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "6.4",
  width: "9.4",
  height: "7.6",
  rx: "1",
  stroke: "#fff",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.8 3.9a2.9 2.9 0 115.8 0v1.7H2.8V3.9z",
  stroke: "#fff",
  strokeWidth: "2"
})));